var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.833 15v-5a.833.833 0 1 1 1.667 0v5c0 1.378-1.122 2.5-2.5 2.5H5A2.503 2.503 0 0 1 2.5 15V5c0-1.378 1.122-2.5 2.5-2.5h5a.833.833 0 1 1 0 1.667H5A.834.834 0 0 0 4.167 5v10c0 .46.373.833.833.833h10c.46 0 .833-.374.833-.833ZM14.648 4.173l-1.319-.006a.833.833 0 0 1 .004-1.667h.005l3.33.017c.459.002.83.374.83.832l.002 3.317c0 .46-.372.834-.832.834h-.001a.833.833 0 0 1-.834-.832V5.346l-5.244 5.243a.831.831 0 0 1-1.178 0 .832.832 0 0 1 0-1.178l5.237-5.238Z",
    fill: "#008545"
  })));
};
export default SvgExternalLink;